import {
	LIST_GET_STATUS,
	LIST_GET_ERROR,

	LISTS_GET_META,
	LIST_GET,
	LISTS_CLEAR
} from '@/store/list/types'

const initialState = {
	loading: false,

	listsMeta: [],
	lists: null,
	listsPageMeta: null
}

export const state = { ...initialState }

export default {
	[LIST_GET_STATUS]: (state, status) => {
		state.loading = status
	},
	[LIST_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[LISTS_GET_META]: (state, payload) => {
		state.listsMeta = payload
	},
	[LIST_GET]: (state, payload) => {
		const {
			data,
			name,
			pageCount,
			perPage,
			totalCount,
			currentPage
		} = payload
		state.lists = {...state.lists, [name]: state.lists && state.lists[name] ? [...state.lists[name], ...data] : data}
		state.listsPageMeta = {...state.listsPageMeta, [name]: {pageCount, totalCount, perPage, currentPage}}
	},
	[LISTS_CLEAR]: (state) => {
		state.lists = null
		state.listsMeta = []
		state.listsPageMeta = null
	}
}

